// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3LRcK","boxTitle":"Qualiphy_boxTitle__16xXF","box":"Qualiphy_box__1ne_8","toggleWrap":"Qualiphy_toggleWrap__3mpaw"};